import React, { useEffect, useRef, useState } from "react";
import { Button, Card, Form, Modal, ProgressBar, Spinner } from "react-bootstrap";
import { Add } from "iconsax-react";
import DynamicLogo from "../../../pages/DynamicLogoLoader";
import MyApiClient from "../../../../api-client/MyApiClient";
import DEFAULT_STRUTTURA from "../../../../images/DEFAULT_STRUTTURA.png";
import ProductImageUploader from "../../Util/ProductImageUploader";
import {
    aggiungiFotoGalleria, cambiaDidascalia, riordinaGalleria, togliFotoGalleria,
    caricaVideoPresentazione, salvaOpzioniScheda, statoVideoPresentazione, togliVideoPresentazione,
} from "../../../../api-client/appPlayer";
import { indirizzoIncorporato, leggiLinkVideo } from "../SchedaApp/videoLink";

/*
 * Foto e video della struttura (sportid-docs, interventi del 7-8/10/2026, sez. C, D, E).
 * Due riquadri «+» a fine lista: foto (nome, didascalia e, se serve, «è il logo») e video
 * (link YouTube/Vimeo oppure file fino a 10 MB). Sotto: il logo a parte, le foto in ordine (la prima e` la
 * grande, la seconda e la terza a destra, le altre in galleria) e i video.
 */

const MAX_FOTO = 20;
const MAX_DIDASCALIA = 140;
const MAX_VIDEO_BYTES = 10 * 1024 * 1024;
const STATO_VIDEO = { PENDING: 'In attesa di approvazione', REJECTED: 'Non approvato' };

const posizione = (i) => (i === 0 ? 'Foto grande' : i < 3 ? 'A destra' : 'Nella galleria');
const nomeJpg = (nome) => `${String(nome || 'foto').trim().replace(/\.[a-z0-9]{2,5}$/i, '') || 'foto'}.jpg`;

export const FormFoto = (props) => {
    const disabilitato = props.isDisabled;
    const club = props.profile?.club;

    const [logo, setLogo] = useState(null);
    const [foto, setFoto] = useState([]);
    const [dettaglio, setDettaglio] = useState(null);
    const [testoDett, setTestoDett] = useState('');
    const [videoLink, setVideoLink] = useState('');
    const [intro, setIntro] = useState(null);

    const [aggiungi, setAggiungi] = useState(false);
    const [nome, setNome] = useState('');
    const [didascalia, setDidascalia] = useState('');
    const [eLogo, setELogo] = useState(false);

    const [videoAperto, setVideoAperto] = useState(false);
    const [modo, setModo] = useState('link');
    const [link, setLink] = useState('');
    const [linkRosso, setLinkRosso] = useState(false);
    const [file, setFile] = useState(null);
    const [progresso, setProgresso] = useState(null);
    const inputVideo = useRef(null);

    const [daTogliere, setDaTogliere] = useState(null);
    const [togliVideo, setTogliVideo] = useState(null);
    const [togliLogo, setTogliLogo] = useState(false);
    const [trascinata, setTrascinata] = useState(null);
    const [errore, setErrore] = useState('');
    const [inCorso, setInCorso] = useState(false);
    const [salvato, setSalvato] = useState(false);

    useEffect(() => {
        if (!club) return;
        setLogo(club.logo || null);
        setFoto(club.pictures || []);
        setVideoLink(club.videoUrl || '');
    }, [club]);
    useEffect(() => {
        if (disabilitato) return;
        statoVideoPresentazione().then((r) => setIntro(r?.error ? {} : r));
    }, [disabilitato]);
    useEffect(() => {
        if (!salvato) return undefined;
        const t = setTimeout(() => setSalvato(false), 2500);
        return () => clearTimeout(t);
    }, [salvato]);

    const apriAggiungi = (comeLogo = false) => { setNome(''); setDidascalia(''); setELogo(comeLogo === true); setAggiungi(true); };
    const chiudiAggiungi = () => setAggiungi(false);

    /* ── Salvataggio ── */

    const salvaLogo = async (base64) => {
        // Il backend toglie il logo quando riceve una stringa vuota
        const tds = sessionStorage.getItem('userDetails');
        if (!tds) return;
        setInCorso(true);
        try {
            const profiloDaInviare = JSON.parse(JSON.stringify(props.profile));
            profiloDaInviare.club.logo = base64;
            delete profiloDaInviare.club.pictures;
            const r = await new MyApiClient().updateProfile(JSON.parse(tds).idToken, profiloDaInviare);
            if (r?.error || !r?.data?.club) { setErrore(`Si è verificato un errore durante il salvataggio (${r?.error || 'risposta non valida'})`); return; }
            const td = JSON.parse(tds);
            td.logo = r.data.club.logo;
            sessionStorage.setItem('userDetails', JSON.stringify(td));
            setLogo(r.data.club.logo || null);
            setSalvato(true);
        } catch (e) {
            setErrore('Si è verificato un errore durante il salvataggio. Riprova.');
        } finally {
            setInCorso(false);
        }
    };

    const confermaTogliLogo = async () => {
        setTogliLogo(false);
        await salvaLogo('');
    };

    const salvaFoto = async (base64) => {
        chiudiAggiungi();
        if (eLogo) { await salvaLogo(base64); return; }
        setInCorso(true);
        try {
            const r = await aggiungiFotoGalleria(base64, nomeJpg(nome), didascalia.trim());
            if (r?.error) { setErrore(r.error); return; }
            setFoto((f) => [...f, r]);
            setSalvato(true);
        } catch (e) {
            setErrore('Non è stato possibile salvare la foto. Riprova.');
        } finally {
            setInCorso(false);
        }
    };

    const apriDettaglio = (p) => { setDettaglio(p); setTestoDett(p.caption || ''); };
    const salvaDidascalia = async () => {
        const p = dettaglio;
        const nuova = testoDett.trim();
        setDettaglio(null);
        if (nuova === (p.caption || '')) return;
        const r = await cambiaDidascalia(p.id, nuova);
        if (r?.error) { setErrore(r.error); return; }
        setFoto((f) => f.map((x) => (x.id === p.id ? { ...x, caption: r.caption } : x)));
        setSalvato(true);
    };

    const riordina = async (da, a) => {
        if (da === a || da < 0 || a < 0 || da >= foto.length || a >= foto.length) return;
        const nuove = [...foto];
        const [spostata] = nuove.splice(da, 1);
        nuove.splice(a, 0, spostata);
        const prima = foto;
        setFoto(nuove);
        const r = await riordinaGalleria(nuove.map((p) => p.id));
        if (r?.error) { setFoto(prima); setErrore(r.error); return; }
        setSalvato(true);
    };

    const togliFoto = async () => {
        const p = daTogliere;
        setDaTogliere(null);
        const r = await togliFotoGalleria(p.id);
        if (r?.error) { setErrore(r.error); return; }
        setFoto((f) => f.filter((x) => x.id !== p.id));
    };

    /* ── Video ── */

    const apriVideo = () => { setModo('link'); setLink(''); setLinkRosso(false); setFile(null); setProgresso(null); setVideoAperto(true); };

    const scegliFile = (e) => {
        const f = e.target.files?.[0];
        e.target.value = '';
        if (!f) return;
        if (f.type !== 'video/mp4') { setErrore('Il video deve essere in formato MP4.'); return; }
        if (f.size > MAX_VIDEO_BYTES) { setErrore(`Il video pesa ${(f.size / (1024 * 1024)).toFixed(1)} MB, il massimo è 10 MB.`); return; }
        setFile(f);
    };

    const salvaVideo = async () => {
        if (modo === 'link') {
            if (!leggiLinkVideo(link)) { setLinkRosso(true); return; }
            setInCorso(true);
            try {
                const r = await salvaOpzioniScheda({ videoUrl: link.trim() });
                if (r?.error) { setErrore(r.error); return; }
                setVideoLink(link.trim());
                setVideoAperto(false);
                setSalvato(true);
            } catch (e) {
                setErrore('Non è stato possibile salvare il video. Riprova.');
            } finally {
                setInCorso(false);
            }
            return;
        }
        setProgresso(0);
        const r = await caricaVideoPresentazione(file, undefined, setProgresso);
        setProgresso(null);
        if (r?.error) { setErrore(r.error); return; }
        setIntro(r);
        setVideoAperto(false);
        setSalvato(true);
    };

    const confermaTogliVideo = async () => {
        const quale = togliVideo;
        setTogliVideo(null);
        if (quale === 'link') {
            const r = await salvaOpzioniScheda({ videoUrl: '' });
            if (r?.error) { setErrore(r.error); return; }
            setVideoLink('');
        } else {
            const r = await togliVideoPresentazione();
            if (r?.error) { setErrore(r.error); return; }
            setIntro({});
        }
        setSalvato(true);
    };

    const anteprimaLink = leggiLinkVideo(videoLink);
    const haIntro = intro?.approved || intro?.review;

    const campiFoto = (
        <div className="mt-3">
            <Form.Label htmlFor="foto-nome">Nome del file</Form.Label>
            <Form.Control id="foto-nome" value={nome} maxLength={80} onChange={(e) => setNome(e.target.value)} />
            {!eLogo && (
                <>
                    <Form.Label htmlFor="foto-didascalia" className="mt-3">Didascalia (facoltativa)</Form.Label>
                    <Form.Control id="foto-didascalia" value={didascalia} maxLength={MAX_DIDASCALIA} onChange={(e) => setDidascalia(e.target.value)} />
                    <Form.Text className="text-dark">{didascalia.length}/{MAX_DIDASCALIA}</Form.Text>
                </>
            )}
            <Form.Check
                type="switch"
                id="foto-e-logo"
                className="mt-3"
                label="Questa immagine è il logo della struttura"
                checked={eLogo}
                onChange={(e) => setELogo(e.target.checked)}
            />
        </div>
    );

    return (
        <>
            <Modal show={!!errore} onHide={() => setErrore('')} centered>
                <Modal.Header closeButton><Modal.Title>Errore durante l'operazione</Modal.Title></Modal.Header>
                <Modal.Body>{errore}</Modal.Body>
            </Modal>
            <Modal show={inCorso} centered>
                <Modal.Body className="text-center"><Spinner animation="border" role="status" /><div>Salvataggio in corso...</div></Modal.Body>
            </Modal>
            <Modal show={!!daTogliere} onHide={() => setDaTogliere(null)} centered>
                <Modal.Header closeButton><Modal.Title>Togliere la foto?</Modal.Title></Modal.Header>
                <Modal.Body>La foto sparisce dalla scheda della struttura nell'app.</Modal.Body>
                <Modal.Footer className="justify-content-center sid-footer-conferma">
                    <Button className="btn btn-light btn-add" onClick={() => setDaTogliere(null)}>Annulla</Button>
                    <Button className="btn btn-danger btn-add" onClick={togliFoto}>Rimuovi</Button>
                </Modal.Footer>
            </Modal>
            <Modal show={togliLogo} onHide={() => setTogliLogo(false)} centered>
                <Modal.Header closeButton><Modal.Title>Togliere il logo?</Modal.Title></Modal.Header>
                <Modal.Body>Il logo sparisce dalla struttura, dall'app e dai documenti.</Modal.Body>
                <Modal.Footer className="justify-content-center sid-footer-conferma">
                    <Button className="btn btn-light btn-add" onClick={() => setTogliLogo(false)}>Annulla</Button>
                    <Button className="btn btn-danger btn-add" onClick={confermaTogliLogo}>Rimuovi</Button>
                </Modal.Footer>
            </Modal>
            <Modal show={!!togliVideo} onHide={() => setTogliVideo(null)} centered>
                <Modal.Header closeButton><Modal.Title>Togliere il video?</Modal.Title></Modal.Header>
                <Modal.Body>Il video sparisce dalla scheda della struttura nell'app.</Modal.Body>
                <Modal.Footer className="justify-content-center sid-footer-conferma">
                    <Button className="btn btn-light btn-add" onClick={() => setTogliVideo(null)}>Annulla</Button>
                    <Button className="btn btn-danger btn-add" onClick={confermaTogliVideo}>Rimuovi</Button>
                </Modal.Footer>
            </Modal>

            <Modal show={!!dettaglio} onHide={() => setDettaglio(null)} centered>
                <Modal.Header closeButton><Modal.Title>Foto</Modal.Title></Modal.Header>
                <Modal.Body>
                    {dettaglio && <img src={dettaglio.uri} alt="" className="sid-galleria__dettaglio" />}
                    <Form.Label htmlFor="didascalia-dettaglio" className="mt-3">Didascalia</Form.Label>
                    <Form.Control
                        id="didascalia-dettaglio"
                        value={testoDett}
                        maxLength={MAX_DIDASCALIA}
                        readOnly={disabilitato}
                        onChange={(e) => setTestoDett(e.target.value)}
                    />
                    <Form.Text className="text-dark">{testoDett.length}/{MAX_DIDASCALIA}</Form.Text>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="btn btn-light btn-add" onClick={() => setDettaglio(null)}>Chiudi</Button>
                    {!disabilitato && <Button className="btn btn-primary btn-add" onClick={salvaDidascalia}>Salva</Button>}
                </Modal.Footer>
            </Modal>

            {/* Foto: la stessa finestra per le foto e per il logo; cambia solo la forma del ritaglio */}
            <ProductImageUploader
                show={aggiungi}
                onClose={chiudiAggiungi}
                onSave={salvaFoto}
                titolo={eLogo ? 'Logo della struttura' : 'Foto della struttura'}
                larghezza={eLogo ? 400 : 1280}
                altezza={eLogo ? 400 : 720}
                formato={eLogo ? 'png' : 'jpeg'}
                onFileScelto={(n) => setNome((attuale) => attuale || n.replace(/\.[a-z0-9]{2,5}$/i, ''))}
                extra={campiFoto}
                salvaDisabilitato={!nome.trim()}
            />

            <Modal show={videoAperto} onHide={() => progresso === null && setVideoAperto(false)} centered>
                <Modal.Header closeButton><Modal.Title>Carica video</Modal.Title></Modal.Header>
                <Modal.Body>
                    <div className="sid-scelta-modo mb-3">
                        <button type="button" className={modo === 'link' ? 'is-attiva' : ''} onClick={() => setModo('link')}>Link</button>
                        <button type="button" className={modo === 'file' ? 'is-attiva' : ''} onClick={() => setModo('file')}>File</button>
                    </div>
                    {modo === 'link' ? (
                        <>
                            <Form.Label htmlFor="video-link" className={linkRosso ? 'text-danger' : ''}>Link di YouTube o Vimeo</Form.Label>
                            <Form.Control
                                id="video-link"
                                value={link}
                                maxLength={300}
                                isInvalid={linkRosso}
                                onChange={(e) => { setLink(e.target.value); if (linkRosso) setLinkRosso(!!e.target.value.trim() && !leggiLinkVideo(e.target.value)); }}
                            />
                            <Form.Text className="text-dark">Il video deve essere pubblico o «non in elenco», con l'incorporamento consentito.</Form.Text>
                        </>
                    ) : (
                        <>
                            <input ref={inputVideo} type="file" accept="video/mp4" hidden onChange={scegliFile} />
                            <Button type="button" className="btn btn-light btn-add" onClick={() => inputVideo.current?.click()} disabled={progresso !== null}>
                                {file ? 'Scegli un altro file' : 'Scegli il file'}
                            </Button>
                            {file && <div className="mt-2"><strong>{file.name}</strong> · {(file.size / (1024 * 1024)).toFixed(1)} MB</div>}
                            <Form.Text className="d-block text-dark mt-2">
                                MP4 verticale, al massimo 10 MB e 10 secondi. Prima di comparire nell'app lo approva SportID.
                            </Form.Text>
                            {progresso !== null && <ProgressBar className="mt-3" now={Math.round(progresso * 100)} label={`${Math.round(progresso * 100)}%`} />}
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button className="btn btn-light btn-add" onClick={() => setVideoAperto(false)} disabled={progresso !== null}>Annulla</Button>
                    <Button
                        className="btn btn-primary btn-add"
                        onClick={salvaVideo}
                        disabled={progresso !== null || (modo === 'link' ? !link.trim() : !file)}
                    >
                        {modo === 'link' ? 'Salva' : 'Carica'}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Card className="sid-galleria">
                <Card.Body className="sid-card-body--spaced">
                    <div className="sid-sezione-azione"><h5 className="sid-form-section">Foto</h5></div>
                    {foto.length > 0 && (
                        <p className="sid-nota-leggibile">
                            Trascina le foto per cambiare l'ordine: la prima è la grande, la seconda e la terza stanno a destra, le altre sono nella galleria.
                        </p>
                    )}
                    <div className="sid-galleria__riga">
                        {/* Il logo e` sempre al primo posto: sta fuori dall'ordine delle foto, diviso da una barra */}
                        <div className="sid-galleria__foto sid-galleria__logo">
                            <div
                                className="sid-galleria__immagine sid-galleria__immagine--logo"
                                role={disabilitato ? undefined : 'button'}
                                tabIndex={disabilitato ? undefined : 0}
                                title={disabilitato ? undefined : (logo ? 'Sostituisci il logo' : 'Aggiungi il logo')}
                                onClick={() => !disabilitato && apriAggiungi(true)}
                                onKeyDown={(e) => !disabilitato && e.key === 'Enter' && apriAggiungi(true)}
                            >
                                {logo
                                    ? <DynamicLogo logoUrl={logo} altText="Logo Struttura Sportiva" />
                                    : <img src={DEFAULT_STRUTTURA} alt="" />}
                                <span className="sid-galleria__posizione">{logo ? 'Logo' : 'Nessun logo'}</span>
                                {logo && !disabilitato && (
                                    <button type="button" className="sid-galleria__x" aria-label="Togli il logo" onClick={(e) => { e.stopPropagation(); setTogliLogo(true); }}>×</button>
                                )}
                            </div>
                        </div>
                        <div className="sid-galleria__barra" aria-hidden="true" />
                        <div className="sid-galleria__griglia">
                        {foto.map((p, i) => (
                            <div
                                className={`sid-galleria__foto ${trascinata === i ? 'is-trascinata' : ''}`}
                                key={p.id}
                                draggable={!disabilitato}
                                onDragStart={() => setTrascinata(i)}
                                onDragOver={(e) => e.preventDefault()}
                                onDrop={() => { if (trascinata !== null) riordina(trascinata, i); setTrascinata(null); }}
                                onDragEnd={() => setTrascinata(null)}
                            >
                                <div className="sid-galleria__immagine" role="button" tabIndex={0} onClick={() => apriDettaglio(p)} onKeyDown={(e) => e.key === 'Enter' && apriDettaglio(p)}>
                                    <img src={p.uri} alt={p.caption || ''} draggable={false} />
                                    <span className="sid-galleria__posizione">{i + 1} · {posizione(i)}</span>
                                    {!disabilitato && (
                                        <button type="button" className="sid-galleria__x" aria-label="Togli la foto" onClick={(e) => { e.stopPropagation(); setDaTogliere(p); }}>×</button>
                                    )}
                                </div>
                            </div>
                        ))}
                        {!disabilitato && foto.length < MAX_FOTO && (
                            <button type="button" className="sid-galleria__aggiungi" aria-label="Aggiungi foto" onClick={() => apriAggiungi()}>
                                <Add size={28} />
                            </button>
                        )}
                        </div>
                    </div>

                                        <div className="sid-sezione-azione"><h5 className="sid-form-section">Video</h5></div>
                    <div className="sid-video-verticale__fila">
                        {anteprimaLink && (
                            <div>
                                <div className="sid-video-verticale__etichetta">Link YouTube o Vimeo</div>
                                <div className="sid-video-link">
                                    <iframe src={indirizzoIncorporato(anteprimaLink)} title="Anteprima del video" allow="encrypted-media; picture-in-picture" allowFullScreen />
                                </div>
                                {!disabilitato && <Button type="button" className="btn btn-outline-danger sid-btn-compatto mt-2" onClick={() => setTogliVideo('link')}>Togli</Button>}
                            </div>
                        )}
                        {intro?.approved && (
                            <div className="sid-video-verticale">
                                <div className="sid-video-verticale__etichetta">Nell'app</div>
                                <video src={intro.approved.url} controls playsInline preload="metadata" />
                            </div>
                        )}
                        {intro?.review && (
                            <div className="sid-video-verticale">
                                <div className="sid-video-verticale__etichetta">{STATO_VIDEO[intro.review.status] || intro.review.status}</div>
                                <video src={intro.review.url} controls playsInline preload="metadata" />
                                {intro.review.status === 'REJECTED' && intro.review.rejectReason && <div className="mt-2"><strong>Motivo:</strong> {intro.review.rejectReason}</div>}
                            </div>
                        )}
                        {!disabilitato && (
                            <button type="button" className="sid-galleria__aggiungi sid-galleria__aggiungi--video" aria-label="Carica video" onClick={apriVideo}>
                                <Add size={28} />
                            </button>
                        )}
                    </div>
                    {haIntro && !disabilitato && (
                        <div><Button type="button" className="btn btn-outline-danger sid-btn-compatto" onClick={() => setTogliVideo('file')}>Togli il video caricato</Button></div>
                    )}
                </Card.Body>
            </Card>
            {salvato && <div className="sid-avviso-salvato" role="status">✓ Modifica salvata</div>}
        </>
    );
};

export default FormFoto;
